module.exports = __webpack_public_path__ + "static/media/2_profil.87eb9990.png";